import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";
import SVGComponent from "./SVGComponent";
import { strokeDashTypes } from "../utils";
import {
  extractThresholdValue,
  extractThresholdLine,
  clipToBand,
  clipOutsideBand,
  bandClipRects,
} from "./oscillatorThresholds";

class UltimateOscillatorSeries extends Component {
  constructor(props) {
    super(props);
    this.renderClip = this.renderClip.bind(this);
    this.topAndBottomClip = this.topAndBottomClip.bind(this);
    this.mainClip = this.mainClip.bind(this);

    const id1 = String(Math.round(Math.random() * 10000 * 10000));
    this.clipPathId1 = `ultimate-oscillator-clip-${id1}`;

    const id2 = String(Math.round(Math.random() * 10000 * 10000));
    this.clipPathId2 = `ultimate-oscillator-clip-${id2}`;
  }
  topAndBottomClip(ctx, moreProps) {
    const { overSold, overBought } = this.props;
    clipToBand(
      ctx,
      moreProps,
      extractThresholdValue(overBought, 70),
      extractThresholdValue(overSold, 30),
    );
  }
  mainClip(ctx, moreProps) {
    const { overSold, overBought } = this.props;
    clipOutsideBand(
      ctx,
      moreProps,
      extractThresholdValue(overBought, 70),
      extractThresholdValue(overSold, 30),
    );
  }
  renderClip(moreProps) {
    const { overSold, overBought } = this.props;
    const { overBoughtY, overSoldY, width, height } = bandClipRects(
      moreProps,
      extractThresholdValue(overBought, 70),
      extractThresholdValue(overSold, 30),
    );

    return (
      <defs>
        <clipPath id={this.clipPathId1}>
          <rect
            x={0}
            y={overBoughtY}
            width={width}
            height={overSoldY - overBoughtY}
          />
        </clipPath>
        <clipPath id={this.clipPathId2}>
          <rect x={0} y={0} width={width} height={overBoughtY} />
          <rect x={0} y={overSoldY} width={width} height={height - overSoldY} />
        </clipPath>
      </defs>
    );
  }
  render() {
    const { className, stroke, onContextMenu, showZones } = this.props;
    const { yAccessor } = this.props;
    const { overSold, overBought } = this.props;

    const overBoughtData = extractThresholdLine(overBought, 70, {
      color: "#0000FF",
      dash: "ShortDash",
      width: 1,
      opacity: 1,
    });
    const overSoldData = extractThresholdLine(overSold, 30, {
      color: "#FF0000",
      dash: "ShortDash",
      width: 1,
      opacity: 1,
    });

    // Handle both simple stroke object and complex stroke structure for main line
    const oscillatorStroke = stroke.line ? stroke.line : stroke;

    const style1 = { clipPath: `url(#${this.clipPathId1})` };
    const style2 = { clipPath: `url(#${this.clipPathId2})` };

    // Determine if zones should be shown (default to true for backwards compatibility)
    const shouldShowZones = showZones !== false;

    return (
      <g className={className}>
        <SVGComponent>{this.renderClip}</SVGComponent>
        {shouldShowZones && (
          <StraightLine
            stroke={overSoldData.stroke}
            yValue={overSoldData.value}
            onContextMenu={onContextMenu}
          />
        )}
        {shouldShowZones && (
          <StraightLine
            stroke={overBoughtData.stroke}
            yValue={overBoughtData.value}
            onContextMenu={onContextMenu}
          />
        )}
        <LineSeries
          style={style1}
          canvasClip={this.topAndBottomClip}
          className={className}
          yAccessor={yAccessor}
          stroke={oscillatorStroke}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          style={style2}
          canvasClip={this.mainClip}
          className={className}
          yAccessor={yAccessor}
          stroke={oscillatorStroke}
          onContextMenu={onContextMenu}
        />
      </g>
    );
  }
}

UltimateOscillatorSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.oneOfType([
    // Simple stroke object (from form)
    PropTypes.shape({
      color: PropTypes.string,
      opacity: PropTypes.number,
      width: PropTypes.number,
      dash: PropTypes.oneOf(strokeDashTypes),
    }),
    // Complex stroke structure (backwards compatibility)
    PropTypes.shape({
      line: PropTypes.shape({
        color: PropTypes.string,
        opacity: PropTypes.number,
        width: PropTypes.number,
        dash: PropTypes.oneOf(strokeDashTypes),
      }),
      top: PropTypes.shape({
        color: PropTypes.string,
        opacity: PropTypes.number,
        width: PropTypes.number,
        dash: PropTypes.oneOf(strokeDashTypes),
      }).isRequired,
      bottom: PropTypes.shape({
        color: PropTypes.string,
        opacity: PropTypes.number,
        width: PropTypes.number,
        dash: PropTypes.oneOf(strokeDashTypes),
      }).isRequired,
      outsideThreshold: PropTypes.shape({
        color: PropTypes.string,
        opacity: PropTypes.number,
        width: PropTypes.number,
        dash: PropTypes.oneOf(strokeDashTypes),
      }).isRequired,
      insideThreshold: PropTypes.shape({
        color: PropTypes.string,
        opacity: PropTypes.number,
        width: PropTypes.number,
        dash: PropTypes.oneOf(strokeDashTypes),
      }).isRequired,
    }),
  ]).isRequired,
  overSold: PropTypes.number.isRequired,
  overBought: PropTypes.number.isRequired,
  showZones: PropTypes.bool,
  onContextMenu: PropTypes.func,
};

UltimateOscillatorSeries.defaultProps = {
  className: "react-stockcharts-ultimate-oscillator-series",
  stroke: { color: "#9C27B0", opacity: 1, width: 1, dash: "Solid" },
  overSold: 30,
  overBought: 70,
  showZones: true,
};

export default UltimateOscillatorSeries;
